import {makeStyles} from "@material-ui/core";
import {grey} from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "auto",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  contentWrapper: {
    marginTop: "auto",
    marginBottom: "auto",
    outline: "none",
    zIndex: 1,
  },
  modalPaper: {
    borderRadius: "8px",
    backgroundColor: theme.palette.common.white,
    width: "480px",
    outline: "none !important",
    "&:focus": {
      outline: "none !important",
    },
    padding: theme.spacing(3),
  },
  backdrop: {
    backgroundColor: "rgba(0, 0, 0, 0.8)",
  },
  lightBackdrop: {
    backgroundColor: "rgba(0, 0, 0, 0.4)",
  },
  title: {
    fontSize: "24px",
    fontWeight: 500,
  },
  subtitle: {
    fontSize: "14px",
    color: theme.palette.grey[600],
  },
  paper: {
    padding: theme.spacing(3, 3, 2),
  },
  header: {
    borderBottom: `1px solid ${grey[300]}`,
    padding: theme.spacing(3, 3, 2),
  },
  body: {
    padding: theme.spacing(3, 3, 2),
  },
  footer: {
    borderTop: `1px solid ${grey[300]}`,
    padding: theme.spacing(3, 3, 2),
  },
}));
